module.exports = __webpack_public_path__ + "img/Terrassenunterkonstruktion.d446dd58.jpg";